var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPadlock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 14,
    viewBox: "0 0 11 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.83666 5.79853H9.25633H9.25618V3.812C9.25615 1.7101 7.49657 0 5.33371 0C3.17097 0 1.41134 1.7101 1.41134 3.81203V5.79856H0.830888C0.372039 5.79856 0 6.16006 0 6.60602V7.09724V12.7013V13.1925C0 13.6385 0.372009 14 0.830888 14H5.33374H9.83666C10.2955 14 10.6675 13.6385 10.6675 13.1925V12.7013V7.09724V6.60602C10.6675 6.16003 10.2955 5.79853 9.83666 5.79853ZM6.21812 11.5826H4.4494L4.76596 10.1166C4.46991 9.93356 4.27217 9.61386 4.27217 9.24757C4.27217 8.67782 4.74749 8.21594 5.33374 8.21594C5.92002 8.21594 6.39526 8.67782 6.39526 9.24757C6.39526 9.61386 6.19757 9.93356 5.90156 10.1166L6.21812 11.5826ZM7.8566 5.79853H5.33374H2.81104H2.81089V3.812C2.81089 2.45994 3.94257 1.36015 5.33374 1.36015C6.72498 1.36015 7.8566 2.45997 7.8566 3.812V5.79853Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPadlock);
export default __webpack_public_path__ + "static/media/padlock.4f86855829f21495a1472e9ec09e1ce1.svg";
export { ForwardRef as ReactComponent };